import { ReactNode } from 'react';

import { Box } from '@mui/material';

import { RouterLink } from '@/components';

export const Card = ({
  bottomLink,
  children,
}: {
  bottomLink?: { link: string; text: string };
  children: ReactNode;
}) => {
  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        padding: 2,
        borderRadius: 1,
        boxShadow: '0 0.25rem 1rem 0 #4E505429',
      }}
    >
      {children}

      {
        <Box display="flex" justifyContent="center" width="100%" sx={{ mt: 2 }}>
          <RouterLink to={bottomLink?.link ?? '/'} fontSize={13}>
            {bottomLink?.text}
          </RouterLink>
        </Box>
      }
    </Box>
  );
};
